module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chat-0185efb2f2cf202e6062f2540389d847.svg";